import React, { Fragment } from "react";
import { Button, Divider, Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import StatusField from "components/StatusField";
import {
  Datagrid,
  Filter,
  List,
  TextField,
  SearchInput,
  FunctionField,
  ReferenceField,
  BulkDeleteButton,
  SelectInput,
  BulkDeleteButtonProps,
  ListProps,
} from "react-admin";
import { Helmet } from "react-helmet";
import { statusList } from "./conts";
import VisibilityIcon from "@material-ui/icons/Visibility";
import EditIcon from "@material-ui/icons/Edit";
import { GridinRow, GridLabel } from "utils/style";
import CustomDateField from "components/CustomDateField";
import { SchoolIdSelected } from "utils/tools";
import CustomStatusField from "./components/CustomStatusField";
import InternalNoteParentButton from "./components/InternalNoteParentButton";

const ParentFilter = (props: any) => (
  <Filter {...props}>
    <SearchInput source="search" alwaysOn />
    <SelectInput label="Status" source="Status" choices={statusList} alwaysOn />
  </Filter>
);

const ParentList = (props: ListProps) => {
  const ParentShowButton = (record: IParent) => {
    return (
      <Button href={`/#/parents/${record.id}/show`}>
        <VisibilityIcon />
      </Button>
    );
  };

  const ParentEditButton = (record: IParent) => (
    <Button href={`/#/parents/${record.id}`}>
      <EditIcon />
    </Button>
  );

  return (
    <>
      <Helmet>
        <title>Parents</title>
      </Helmet>
      <List
        exporter={false}
        filters={<ParentFilter />}
        filter={{
          SchoolId: Number(SchoolIdSelected()),
          IsHaveStudent: true,
          searchAllParent: true,
        }}
        sort={{ field: "CreatedAt", order: "DESC" }}
        bulkActionButtons={false}
        {...props}
      >
        <Datagrid>
          <FunctionField
            label="Parent Info"
            render={() => (
              <SanitizedGrid container spacing={2}>
                <Grid item xs={12} style={GridinRow}>
                  <Typography variant="body2" style={GridLabel}>
                    Id :
                  </Typography>
                  <TextField source="id" />
                </Grid>

                <Grid item xs={12} style={GridinRow}>
                  <Typography variant="body2" style={GridLabel}>
                    Name :
                  </Typography>
                  <FunctionField
                    render={(record: any) =>
                      `${record.firstName} ${record.lastName}`
                    }
                  />
                </Grid>

                <Grid item xs={12} style={GridinRow}>
                  <Typography variant="body2" style={GridLabel}>
                    Email :
                  </Typography>
                  <TextField source="user.email" emptyText="-" />
                </Grid>

                <Grid item xs={12} style={GridinRow}>
                  <Typography variant="body2" style={GridLabel}>
                    Mobile :
                  </Typography>
                  <TextField source="mobile" />
                </Grid>

                <Grid item xs={12} style={GridinRow}>
                  <Typography variant="body2" style={GridLabel}>
                    Accounting Customer Id :
                  </Typography>
                  <TextField source="user.accountingCustomerId" />
                </Grid>
              </SanitizedGrid>
            )}
          />
          <FunctionField
            label="Student Info"
            render={(record: any) => (
              <>
                {record.students && (
                  <SanitizedGrid container spacing={2}>
                    {record.students.length > 0 ? (
                      <>
                        {record.students.map(
                          (student: IStudent, index: number) => {
                            return (
                              <Fragment key={`student-key-${index}`}>
                                <Grid item xs={12} style={GridinRow}>
                                  <Typography variant="body2">
                                    Id : {student.id}
                                  </Typography>
                                </Grid>

                                <Grid item xs={12} style={GridinRow}>
                                  <Typography variant="body2">
                                    Name : {student.firstName}{" "}
                                    {student.lastName}
                                  </Typography>
                                </Grid>

                                <Grid item xs={12} style={GridinRow}>
                                  <Typography variant="body2" style={GridLabel}>
                                    School :
                                  </Typography>
                                  <ReferenceField
                                    source={`students[${index}].schoolId`}
                                    reference="schools"
                                    emptyText="-"
                                    link={false}
                                  >
                                    <TextField source="name" />
                                  </ReferenceField>
                                </Grid>

                                <Grid item xs={4} style={GridinRow}>
                                  <Typography variant="body2" style={GridLabel}>
                                    Level :
                                  </Typography>
                                  <ReferenceField
                                    source={`students[${index}].levelId`}
                                    reference="levels"
                                    emptyText="-"
                                    link={false}
                                  >
                                    <TextField source="name" />
                                  </ReferenceField>
                                </Grid>

                                <Grid item xs={4} style={GridinRow}>
                                  <Typography variant="body2" style={GridLabel}>
                                    Class :
                                  </Typography>
                                  <ReferenceField
                                    source={`students[${index}].levelGroupId`}
                                    reference="levelGroups"
                                    emptyText="-"
                                    link={false}
                                  >
                                    <TextField source="name" />
                                  </ReferenceField>
                                </Grid>

                                <Grid item xs={12} style={GridinRow}>
                                  <CustomStatusField title={student.status} />
                                </Grid>

                                <Grid item xs={12} style={GridinRow}>
                                  {/*{student.isMain && (*/}
                                  {/*  <CustomStatusField title={"Main Student"} />*/}
                                  {/*)}*/}

                                  {!student.isMain && (
                                    <>
                                      {student.resource
                                        .split(",")
                                        .map(
                                          (resource: string, index: number) => (
                                            <CustomStatusField
                                              title={resource}
                                              key={`student-relation-status-key-${index}`}
                                            />
                                          )
                                        )}
                                    </>
                                  )}
                                </Grid>

                                {record.students.length - 1 !== index && (
                                  <Grid item xs={8}>
                                    <Divider />
                                  </Grid>
                                )}
                              </Fragment>
                            );
                          }
                        )}
                      </>
                    ) : (
                      <>
                        <Grid item xs={12}>
                          <Typography
                            variant="body2"
                            style={{ fontWeight: "bold", fontStyle: "italic" }}
                          >
                            No access to the students list.
                          </Typography>
                        </Grid>
                      </>
                    )}
                  </SanitizedGrid>
                )}
              </>
            )}
          />
          <CustomDateField source="createdAt" emptyText="-" isDateTime />
          <StatusField source="status" />
          <FunctionField
            label="Actions"
            render={(props: any) => (
              <>
                <ParentShowButton {...props} />
                <ParentEditButton {...props} />
                <InternalNoteParentButton parentId={props.id} />
              </>
            )}
          />
        </Datagrid>
      </List>
    </>
  );
};

export default ParentList;
